module.exports = __webpack_public_path__ + "media/assets/icons/carousel-first-c4a994fed9c6d341fc6937ac47e183d3.png";